var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowed),expression:"isShowed"}],staticClass:"xg-pic-box"},[_c('img',{staticClass:"rounded xg-rect",class:{'xg-main-pic': _vm.isShowed},attrs:{"src":"/images/other.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }